// Registered style module for the ai-error component.
// Covers error panel layout and retry button styling.

const styleElement = document.createElement("dom-module");

styleElement.innerHTML = `<template>
    <style>
    .ai-error {
      width: 100%;
      padding: 14px 16px;
      border-radius: 12px;
      border: 1px solid #f1c3c3;
      background: #fff5f5;
      color: #a61b1b;
      font-family: "Lato", sans-serif;
      font-size: 14px;
      line-height: 20px;
      box-sizing: border-box;
      text-align: left;
    }
    .ai-error__btn {
      margin-top: 10px;
      border: 0;
      background: #3570d2;
      color: #fff;
      border-radius: 8px;
      padding: 10px 12px;
      cursor: pointer;
      font-family: "Lato", sans-serif;
      font-weight: 700;
      font-size: 14px;
    }
    </style>
</template>`;
styleElement.register("error-display-style");
